(() => {
  const init = scope => scope.querySelectorAll('[data-tc-home-journal]').forEach(root => {
    if(root.dataset.nativeDragReady) return;
    const viewport=root.querySelector('.toccay-blog-knowledge__viewport');
    const track=root.querySelector('[data-toccay-blog-track]');
    if(!viewport||!track) return;
    root.dataset.nativeDragReady='true';
    const originals=Array.from(track.children);
    let cycle=0, drag=null, suppressUntil=0, frame=0;
    const cancelMomentum=()=>{cancelAnimationFrame(frame);frame=0;};
    const momentum=initial=>{
      cancelMomentum();
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      let velocity=Math.max(-2.4,Math.min(2.4,initial)),last=performance.now();
      const tick=now=>{
        const dt=Math.min(40,Math.max(0,now-last));last=now;
        const decay=Math.exp(-dt/325);
        viewport.scrollLeft+=velocity*325*(1-decay);wrap();
        velocity*=decay;
        if(Math.abs(velocity)>.025&&root.isConnected)frame=requestAnimationFrame(tick);
        else frame=0;
      };
      if(Math.abs(velocity)>.025)frame=requestAnimationFrame(tick);
    };
    if(originals.length>1){
      const clone=card=>{
        const copy=card.cloneNode(true);
        copy.removeAttribute('data-toccay-blog-original');
        copy.setAttribute('aria-hidden','true');
        copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
        copy.querySelectorAll('a,button,[tabindex]').forEach(el=>el.tabIndex=-1);
        return copy;
      };
      track.prepend(...originals.map(clone));track.append(...originals.map(clone));
    }
    const measure=()=>{
      const next=originals[0].getBoundingClientRect().left-track.firstElementChild.getBoundingClientRect().left;
      if(next>0 && Math.abs(next-cycle)>.5){
        const phase=cycle?((viewport.scrollLeft-cycle)%cycle+cycle)%cycle/cycle:0;
        cycle=next;viewport.scrollLeft=cycle*(1+phase);
      }
    };
    const wrap=()=>{
      if(!cycle) return;
      const old=viewport.scrollLeft;
      let next=old;
      // Leave a wide buffer either side; do not fight subpixel native scrolling.
      if(old<cycle*.5) next+=cycle;
      else if(old>cycle*1.5) next-=cycle;
      if(next!==old){viewport.scrollLeft=next;if(drag)drag.left+=next-old;}
    };
    viewport.addEventListener('scroll',wrap,{passive:true});
    viewport.addEventListener('pointerdown',e=>{
      cancelMomentum();
      if(e.pointerType==='touch'||e.button!==0) return;
      drag={id:e.pointerId,x:e.clientX,left:viewport.scrollLeft,moved:false,lastX:e.clientX,lastTime:performance.now(),velocity:0};
    });
    window.addEventListener('pointermove',e=>{
      if(!drag||drag.id!==e.pointerId) return;
      const dx=e.clientX-drag.x;
      if(!drag.moved&&Math.abs(dx)<5) return;
      if(!drag.moved){drag.moved=true;viewport.setPointerCapture?.(e.pointerId);}
      e.preventDefault();track.classList.add('is-dragging');
      const now=performance.now(),dt=Math.max(1,now-drag.lastTime);
      const speed=(drag.lastX-e.clientX)/dt;
      drag.velocity=dt>100?speed:drag.velocity*.25+speed*.75;
      drag.lastX=e.clientX;drag.lastTime=now;
      viewport.scrollLeft=drag.left-dx;wrap();
    },{passive:false,capture:true});
    const stop=e=>{
      if(!drag||(e.pointerId!==undefined&&e.pointerId!==drag.id)) return;
      if(drag.moved)suppressUntil=Date.now()+350;
      const velocity=drag.moved&&performance.now()-drag.lastTime<100?drag.velocity:0;
      const id=drag.id;drag=null;track.classList.remove('is-dragging');
      if(viewport.hasPointerCapture?.(id))viewport.releasePointerCapture(id);
      if(e.type==='pointerup')momentum(velocity);else cancelMomentum();
    };
    window.addEventListener('pointerup',stop,true);
    window.addEventListener('pointercancel',stop,true);
    window.addEventListener('blur',stop);
    viewport.addEventListener('wheel',cancelMomentum,{passive:true});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)cancelMomentum();});
    viewport.addEventListener('dragstart',e=>e.preventDefault());
    viewport.addEventListener('click',e=>{
      if(Date.now()<suppressUntil){e.preventDefault();e.stopImmediatePropagation();}
    },true);
    viewport.tabIndex=0;
    viewport.addEventListener('keydown',e=>{
      if(e.target!==viewport||!['ArrowLeft','ArrowRight'].includes(e.key))return;
      cancelMomentum();
      e.preventDefault();viewport.scrollLeft+=(e.key==='ArrowRight'?1:-1)*Math.min(viewport.clientWidth*.8,520);
    });
    measure();
    if('ResizeObserver'in window)new ResizeObserver(measure).observe(viewport);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
